import { useMemo } from "react";
import logo from "../assets/logo2.svg";
import { MobileTakeoverCarousel } from "./MobileTakeoverCarousel";

const SHOWCASE_IMAGES: readonly string[] = [
  "/showcase/1.png",
  "/showcase/2.png",
  "/showcase/3.png",
  "/showcase/4.png",
  "/showcase/5.png",
  "/showcase/6.png",
];

const VISIBLE_COUNT = 3;

function pickRandom(pool: readonly string[], count: number): string[] {
  const copy = [...pool];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy.slice(0, count);
}

export function MobileTakeover() {
  const urls = useMemo(() => pickRandom(SHOWCASE_IMAGES, VISIBLE_COUNT), []);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-[var(--bg-default)] px-6 py-10">
      <div className="flex w-full max-w-[360px] flex-col items-center gap-6">
        <img src={logo} alt="IQ Design" className="h-9" />
        <div className="flex w-full flex-col overflow-hidden rounded-2xl bg-[var(--bg-modal)]">
          <MobileTakeoverCarousel urls={urls} />
          <div className="flex flex-col gap-3 px-6 pb-6 pt-6">
            <h2 className="text-[18px] font-semibold leading-6 text-[var(--text-primary)]">
              Welcome to IQ Design
            </h2>
            <p className="text-[16px] font-normal leading-[160%] text-[var(--text-secondary)]">
              For the best and most powerful experience, please use a desktop or
              laptop computer. To continue, visit{" "}
              <a
                href="https://app.iqdesign.ai"
                className="text-[16px] font-normal leading-[160%] text-[var(--text-secondary)] underline"
                target="_blank"
                rel="noopener"
              >
                app.iqdesign.ai
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
